import { URL_REG_EXPS } from './url-reg-exps';

export const getProjectCategoriesVisibility = (pathname: string): boolean =>
  !URL_REG_EXPS.some((regexp: RegExp) => pathname.match(regexp));
